import React from 'react';
import { Form, Radio, Button, Typography } from 'antd';
import './Step7.css'; // Import the CSS file

const { Title, Paragraph } = Typography;

const Step7 = ({ form, next, prev }) => {
  const [formInstance] = Form.useForm();

  const onFinish = (values) => {
    console.log('Step 7 values:', values);
    next();
  };

  return (
    <Form
      form={formInstance}
      layout="vertical"
      name="step7"
      onFinish={onFinish}
      initialValues={{ fee: undefined }} // Remove default value to ensure user selection
    >
      <Title level={2}>Opera Taxis Driver ID Fee</Title>
      <Paragraph>
        The Opera Taxis Driver ID fee is $30 for 1 year.
      </Paragraph>
      <Form.Item
        name="fee"
        rules={[{ required: true, message: 'Please select a fee option!' }]}
      >
        <Radio.Group className="custom-radio-group">
          <Radio value="30usd">1 year - $30</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item>
        <Button onClick={prev} style={{ marginRight: '8px' }}>
          Back
        </Button>
        <Button type="primary" htmlType="submit">
          Next
        </Button>
      </Form.Item>
    </Form>
  );
};

export default Step7;
